import { useCurrentUser } from "#/components/context/user/UserContext"
import React from "react"
import { useJourney } from "./useJourney"
import { useGetCarrotPlanRequestStatus } from "#/components/carrot-plans/hooks/useCarrotPlanRequestStatus"
import { useCalibratedEngagementEnabled } from "#/hooks/calibratedEngagement/useCalibratedEngagement"
import { useIsMemberInSensitiveState } from "./useIsMemberInSensitiveState"

type UseJourneyDisplay = {
  shouldShowPostCarrotPlanJourneyDisplay: boolean
  shouldShowPreCarrotPlanJourneyDisplay: boolean
  journeyDataIsLoaded: boolean
  resolvedJourney: string | null
  carrotPlanIsOnTheWay: boolean
  isMemberInSensitiveState: boolean
}

export function useJourneyDisplay(): UseJourneyDisplay {
  const { isInAppLockdown } = useCurrentUser()
  const { journeyDataIsLoaded, memberHasJourneyType, resolvedJourney } = useJourney()
  const cpRequestStatusQuery = useGetCarrotPlanRequestStatus()
  const calibratedEngagementEnabled = useCalibratedEngagementEnabled()
  const isMemberInSensitiveState = useIsMemberInSensitiveState()

  const [shouldShowPostCarrotPlanJourneyDisplay, setShouldShowPostCarrotPlanJourneyDisplay] = React.useState(false)
  const [shouldShowPreCarrotPlanJourneyDisplay, setShouldShowPreCarrotPlanJourneyDisplay] = React.useState(false)
  const [carrotPlanIsOnTheWay, setCarrotPlanIsOnTheWay] = React.useState(false)

  React.useEffect(() => {
    if (!journeyDataIsLoaded) return

    const userIsEngaged = !isInAppLockdown && memberHasJourneyType
    const userIsEnrolled = isInAppLockdown

    setCarrotPlanIsOnTheWay(cpRequestStatusQuery.data?.carrotPlanIsOnTheWay)
    setShouldShowPostCarrotPlanJourneyDisplay(userIsEngaged)
    setShouldShowPreCarrotPlanJourneyDisplay(
      userIsEnrolled && !cpRequestStatusQuery.data?.carrotPlanIsOnTheWay && !calibratedEngagementEnabled.data
    )
  }, [
    journeyDataIsLoaded,
    memberHasJourneyType,
    isInAppLockdown,
    cpRequestStatusQuery,
    calibratedEngagementEnabled.data
  ])

  return {
    shouldShowPreCarrotPlanJourneyDisplay,
    shouldShowPostCarrotPlanJourneyDisplay,
    journeyDataIsLoaded,
    resolvedJourney,
    carrotPlanIsOnTheWay,
    isMemberInSensitiveState
  }
}
